import NDialogV2 from './NDialog2';
export { NDialogV2 }
export default NDialogV2;